(function () {
    'use strict';

    angular.module("imApp").factory("departmentService", ['$ihttp', function ($ihttp) {
        let service = {
            getDepartment: function (parms) {
                return $ihttp.post({
                    method: 2228,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2229,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
